import { createSlice, current } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const wiredConfigProvisionings = [
  {
    "id": "72f31915-1a91-4996-9284-111111111111",
    "version": 1,
    "seriesName": "DXS-1210-10TS/A",
    "activeState": true,
    "portConfigs": [
      {
        "portIndex": 1,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 2,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": false,
        "portType": "trunk",
        "PVID": 2,
        "allowVlan": "",
        "poeState": false,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": ["1"],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": false,
        "lbdState": false
      },
      {
        "portIndex": 3,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": false,
        "portType": "trunk",
        "PVID": 2,
        "allowVlan": "",
        "poeState": false,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": ["2"],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": false,
        "lbdState": false
      }
    ]
  },
  {
    "id": "72f31915-1a91-4996-9284-222222222222",
    "version": 1,
    "seriesName": "DXS-1210-16TC/B",
    "activeState": false,
    "portConfigs": [
      {
        "portIndex": 1,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      }
    ]
  },
  {
    "id": "72f31915-1a91-4996-9284-333333333333",
    "version": 1,
    "seriesName": "DGS-1250-28XMP/F",
    "activeState": false,
    "portConfigs": [
      {
        "portIndex": 1,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      }
    ]
  },
]

export const wiredConfigProvisioningsSlice = createSlice({
  name: "wiredConfigProvisionings",
  initialState: {
    resource: "wiredConfigProvisionings",
    data: wiredConfigProvisionings,
    total: wiredConfigProvisionings.length
  },
  reducers: {
    createConfigProvisionings: (state, action) => {
      if(action?.payload?.data?.portConfigs) {
        const mockConfig = {
          id: uuidv4(),
          ...action.payload.data
        }

        const result = [...state.data, mockConfig];
        state.data = result;
      }
    },
    updateConfigProvisionings: (state, action) => {
      const index = state.data.findIndex(config => config.id === action.payload?.data?.id);
      if (index !== -1) state.data[index] = action?.payload?.data;
    },
    deleteConfigProvisionings: (state, action) => {
      state.data = state.data.filter(config => !action.payload?.data?.ids.includes(config.id));
    },
  },
});

export const {
  createConfigProvisionings,
  updateConfigProvisionings,
  deleteConfigProvisionings,
} = wiredConfigProvisioningsSlice.actions;

export default wiredConfigProvisioningsSlice.reducer;
